// TODO: window.onerror = (message, source, line, column, error) => {};
import "@fontsource/roboto"; // default - 400
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/100-italic.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/300-italic.css";
import "@fontsource/roboto/400-italic.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/500-italic.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/700-italic.css";
import "@fontsource/roboto/900.css";
import "@fontsource/roboto/900-italic.css";

import "@fontsource/lato"; // default - 400
import "@fontsource/lato/100.css";
import "@fontsource/lato/100-italic.css";
import "@fontsource/lato/300.css";
import "@fontsource/lato/300-italic.css";
import "@fontsource/lato/400-italic.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/700-italic.css";
import "@fontsource/lato/900.css";
import "@fontsource/lato/900-italic.css";

import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader
import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";

import initVuetify from "./plugins/vuetify";
import "./registerServiceWorker";

import { Auth, initI18n, initRouter, PortalModule, Store } from "@/@core";

import { module as shell, App } from "@/@shell";
import { Configuration } from "@/@core/configuration";

/** Initializes and mounts a Portal instance with the specified modules. */
export async function bootstrap(...modules: PortalModule[]) {
  const urlParams = new URLSearchParams(window.location.search);
  Store.appName = await Configuration.get<string>("appName");
  await Auth.initClaims(
    urlParams.get("jwtPayload") || (Store.get("jwtPayload") as string | null),
    urlParams.get("justAuthenticated") === "true"
  );
  Vue.config.productionTip = false;
  // TODO: do we have some sort of diagnostics API we can POST this to?
  // Vue.config.errorHandler = (err, vm, info) => {
  //   POST /api/diagnostics {err, info, ?}
  // };

  // Vue.use(VueCompositionAPI);

  const i18n = initI18n(modules);
  const vuetify = initVuetify(i18n);
  const router = initRouter(...modules, shell);

  new Vue({
    i18n,
    router,
    vuetify,
    render: h => h(App),
  }).$mount("#app");
}
